import React from 'react';
import { AGENT_PHOTO_DISPLAY } from '../../constants/agentPhotoSpecs';
import './AgentPhoto.css';

const AgentPhoto = ({ src, alt, variant = 'card', className = '' }) => {
  const classes = ['agent-photo', `agent-photo--${variant}`, className].filter(Boolean).join(' ');
  const isProfile = variant === 'profile';
  const display = AGENT_PHOTO_DISPLAY[variant] || AGENT_PHOTO_DISPLAY.card;

  return (
    <img
      src={src}
      alt={alt}
      className={classes}
      width={isProfile ? display.renderWidth : undefined}
      height={isProfile ? display.renderHeight : undefined}
      loading={isProfile ? 'eager' : 'lazy'}
      decoding="async"
      draggable="false"
    />
  );
};

export default AgentPhoto;
